import { set, concat } from '@/utils/vuex'

export default {
  SET_STUDENTS: set('students'),
  SET_LAST_STUDENT: set('lastStudent'),
  SET_EXIST_STUDENTS: set('existNextStudents'),
  CONCAT_STUDENTS: concat('students'),
  SET_SEARCH_VALUE: set('searchValue'),
  SET_SORT_BY: set('sortBy'),
  SET_ORIENTATION: set('orientation'),
  SET_REQUEST_ALL_STUDENTS: set('requestAllStudents'),
  ADD_STUDENT: (state, student) => {
    state.students.unshift(student)
  },
  REMOVE_STUDENT: (state, studentId) => {
    state.students = state.students.filter(student => student.id !== studentId)
  },
  SET_EDITED_STUDENT: set('editedStudent'),
  UPDATE_STUDENT: (state, updatedStudent) => {
    const index = state.students.findIndex(student => student.id === updatedStudent.id)
    if (index !== -1) {
      state.students.splice(index, 1, updatedStudent)
    }
  },
  UPDATE_STUDENT_FLASHCARDS: (state, { id, flashcardsEnabled }) => {
    const index = state.students.findIndex(student => student.id === id)
    if (index !== -1) {
      state.students[index].flashcardsEnabled = flashcardsEnabled
    }
  }
}
